import {Button} from "antd";
import * as React from "react";
import {ButtonProps} from "antd/lib/button/button";
import styling from "./TfButton.module.scss";

const TfButton = (props: ButtonProps & React.RefAttributes<HTMLElement>) => {
    const {className, ...remainingProps } = props
    return <Button className={styling.tfButton} {...remainingProps} />
}

export default TfButton